export default __webpack_public_path__ + "static/media/physics_icon.263aebe4.svg";